import React from 'react';
import { StyledFileIcon } from './styled';

class FileIcon extends React.PureComponent {

  render() {
    const {children} = this.props;
    return (
      <i>
        <StyledFileIcon version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width="100px" height="140px" viewBox="0 0 100 140" enableBackground="new 0 0 100 140" xmlSpace="preserve">
          {children}
        </StyledFileIcon>
      </i>
    );
  }
}

export default FileIcon;



// WEBPACK FOOTER //
// ./src/elements/Icon/FileIcon.jsx